import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { driver_api } from '@/lib/api';
import { toast } from 'sonner';
import { SteeringWheel } from '@phosphor-icons/react';

export default function DriverLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await driver_api.login(email, password);
      if (res.role !== 'driver' && res.role !== 'admin') throw new Error('not driver');
      localStorage.setItem('swift_driver_token', res.token);
      toast.success('Welcome back.');
      nav('/driver');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Invalid email or password.');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center p-6" data-testid="driver-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-12 h-12 rounded-xl bg-brand flex items-center justify-center">
            <SteeringWheel size={24} weight="fill" className="text-white" />
          </div>
          <div className="text-white font-display font-extrabold text-2xl">Inclusive Mobility Driver</div>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 space-y-5" data-testid="driver-login-form">
          <div>
            <label className="label-base">Email</label>
            <input required type="email" value={email} onChange={e => setEmail(e.target.value)} data-testid="driver-login-email" className="input-base" placeholder="you@swift.com.au" />
          </div>
          <div>
            <label className="label-base">Password</label>
            <input required type="password" value={password} onChange={e => setPassword(e.target.value)} data-testid="driver-login-password" className="input-base" />
          </div>
          <button type="submit" disabled={busy} data-testid="driver-login-submit" className="btn-primary w-full">
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
